/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col, Button } from "reactstrap";

// core components

function Footer() {
  return (
    <>
      <footer className="footer footer-black footer-big">
        <Container>
          <Row>
            <Col className="text-center ml-auto mr-auto" md="2" sm="3" xs="12">
              <h4>Svastha</h4>
              <div className="social-area">
                <Button
                  className="btn-just-icon btn-round mr-1"
                  color="facebook"
                >
                  <i className="fa fa-facebook" />
                </Button>
                <Button
                  className="btn-just-icon btn-round mr-1"
                  color="twitter"
                >
                  <i className="fa fa-twitter" />
                </Button>
                <Button className="btn-just-icon btn-round" color="google">
                  <i className="fa fa-google-plus" />
                </Button>
              </div>
            </Col>
            <Col className="ml-auto mr-auto" md="9" sm="9" xs="12">
              <Row>
                <Col md="9" sm="3" xs="6">
                  <Row>
                    <Col md="6">
                      <div className="links">
                        <ul className="uppercase-links stacked-links">
                          <li>
                            <a href="/">Home</a>
                          </li>
                          <li>
                            <a href="/aboutus">About us</a>
                          </li>
                          <li>
                            <a href="/covid">Covid-19</a>
                          </li>
                          <li>
                            <a href="/contribution">Contribution</a>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="links">
                        <ul className="uppercase-links stacked-links">
                          <li>
                            <a href="/twittersearch">Twitter Search</a>
                          </li>
                          <li>
                            <a href="/resources">Resources</a>
                          </li>
                          <li>
                            <a href="/donate">Donate</a>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md="3" sm="3" xs="6">
                  <div className="links">
                    <ul className="stacked-links">
                      <li>
                        <h4>
                          13.723 <br />
                          <small>Visitors</small>
                        </h4>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <hr />
              <div className="copyright">
                <div className="pull-left">
                  © {new Date().getFullYear()} Svastha made with love
                </div>
                <div className="links pull-right">
                  <ul>
                    <li className="mr-1">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        Company Policy
                      </a>
                    </li>
                    |{" "}
                    <li className="mr-1">
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        Terms
                      </a>
                    </li>
                    |{" "}
                    <li>
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        Privacy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default Footer;
